<template>
  <keep-alive>
    <div style="padding: 16px">
      <Tabs
        v-model="tabsValue"
        @on-click="handleTapChange"
        style="margin-top: 20px"
      >
        <TabPane
          v-for="(item, index) in cpList2"
          :label="item.name"
          :name="item.name"
          :key="index"
        ></TabPane>
      </Tabs>
      <el-form :inline="true" :model="formFuzzy">
        <el-form-item>
          <el-input
            v-model="formFuzzy.bookName"
            placeholder="输入图书名称"
          ></el-input>
        </el-form-item>

        <el-form-item>
          <el-input
            v-model="formFuzzy.pressName"
            placeholder="输入出版社名称"
          ></el-input>
        </el-form-item>

        <el-form-item>
          <el-input
            v-model="formFuzzy.IsbnName"
            placeholder="输入ISBN值"
          ></el-input>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="onQuery" icon="el-icon-search"
            >搜索</el-button
          >
        </el-form-item>
        <el-button
          class="btn_multy_add_new_book"
          type="primary"
          icon="el-icon-circle-plus-outline"
          v-show="currCPID != null && haveEditCPRight"
          @click="multyAddBook"
          >批量新建图书</el-button
        >
        <el-button
          class="btn_add_new_book"
          type="primary"
          icon="el-icon-circle-plus-outline"
          v-show="currCPID != null && haveEditCPRight"
          @click="addbook"
          >新建图书</el-button
        >
      </el-form>

      <el-table
        ref="multipleTable"
        :data="queryData"
        :header-cell-style="rowClass"
        tooltip-effect="dark"
        style="width: 100%; font-size: 12px"
        @current-change="handleSelect"
        @selection-change="handleSelectionChange"
        @sort-change="tableSortChg"
        v-loading.body="loading"
      >
        <el-table-column type="selection" width="50"></el-table-column>
        <el-table-column
          prop="id"
          label="ID"
          align="center"
          width="110"
          sortable="custom"
        ></el-table-column>
        <el-table-column
          prop="name"
          label="图书名称"
          align="center"
          min-width="240"
          sortable="custom"
        >
          <template slot-scope="scope">
            <a
              href="javascript:;"
              @click="viewHowEdit(scope.row)"
              style="color: #1d90e6; font-size: 13px"
              >{{ scope.row.name }}</a
            >
          </template>
        </el-table-column>
        <el-table-column
          prop="dbName"
          label="内容提供商"
          align="center"
          min-width="120"
        ></el-table-column>
        <el-table-column
          prop="clevel"
          label="当前状态"
          width="120"
          align="center"
        >
          <template slot-scope="scope">
            <el-tag v-if="scope.row.clevel == 0" type="danger">已下架</el-tag>
            <el-tag v-else-if="scope.row.clevel == 4" type="gray"
              >审核通过</el-tag
            >
            <el-tag v-else-if="scope.row.clevel == 5" type="success"
              >已上架</el-tag
            >
            <el-tag v-else-if="scope.row.clevel == 2" type="primary"
              >编辑中</el-tag
            >
          </template>
        </el-table-column>
        <el-table-column
          prop="updated_at"
          label="更新时间"
          align="center"
          min-width="180"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.updated_at | formatDate2 }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="editor"
          label="编辑账号"
          width="110"
          align="center"
        ></el-table-column>

        <el-table-column
          label="操作"
          show-overflow-tooltip
          align="center"
          width="100"
          fixed="right"
        >
          <template slot-scope="scope">
            <el-tooltip
              class="item"
              effect="dark"
              content="编辑"
              placement="top"
            >
              <el-button
                type="primary"
                size="mini"
                icon="el-icon-edit"
                circle
                @click="handleEdit(scope.row)"
                :disabled="checkBookEditRight(scope.row.dbId)"
              ></el-button>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>
      <el-button type="primary" @click="addbookmsg" style="margin-left: 10px;margin-top: 10px"
        >添加书籍信息</el-button
      >
      <el-button
        type="primary"
        @click="shangxiajia(5)"
        icon="el-icon-arrow-up"
        style="margin-top: 10px"
        v-show="haveEditCPRight"
        >上架</el-button
      >
      <el-button
        type="info"
        @click="shangxiajia(0)"
        icon="el-icon-arrow-down"
        v-show="haveEditCPRight"
        >下架</el-button
      >
      <el-button
        type="danger"
        @click="handleDelete"
        icon="el-icon-delete"
        v-show="haveEditCPRight"
        >删除</el-button
      >
      <div class="pagination-box">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="queryParams.page"
          :page-sizes="[20, 50, 100]"
          :page-size="queryParams.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pageTotal"
        ></el-pagination>
      </div>
      <!-- <el-button type="primary" style="margin-left: 15px" @click="addbookmsg"
        >添加书籍信息</el-button
      > -->
      <!-- <addbookmsg>添加书籍信息</addbookmsg> -->
      <!-- :oldClass="Number(currClassId)"
        v-if="doWhat != 'view'"
        :len="stuSelMultSelection.length"
        :stuData="stuSelMultSelection" -->
      
      <!-- <addbookmsgs
        @chgExpire="chgExpireHandle"
        :len="multipleSelection.length"
        style="margin-left: 10px"
        >修改会员有效期1111</addbookmsgs
      > -->
      <Modal v-model="isedit" width="1000" footer-hide>
        <p slot="header" style="text-align: center; font-size: 15px">
          <Icon type="ios-information-circle"></Icon>
          <span>书籍编辑</span>
        </p>
        <el-form :inline="true" :model="detailInfo" label-width="100px">
          <el-form-item label="适龄: ">
            <el-checkbox-group v-model="tagForDetail.age">
              <el-checkbox
                v-for="item in tagsForAge"
                :label="item.id"
                :key="item.id"
                >{{ item.label }}</el-checkbox
              >
            </el-checkbox-group>
          </el-form-item>
          <br />
          <el-form-item label="出版社: ">
            <el-checkbox-group
              v-model="tagForDetail.publisher"
              :max="1"
              style="width: 800px"
            >
              <el-checkbox
                style="font-size: 10px"
                v-for="item in tagsForPublisher"
                :label="item.id"
                :key="item.id"
                >{{ item.label }}</el-checkbox
              >
            </el-checkbox-group>
          </el-form-item>
          <br />
          <el-form-item label="体裁: ">
            <el-checkbox-group v-model="tagForDetail.form">
              <el-checkbox
                v-for="item in tagsForForm"
                :label="item.id"
                :key="item.id"
                >{{ item.label }}</el-checkbox
              >
            </el-checkbox-group>
          </el-form-item>
          <br />
          <el-form-item label="类型: ">
            <el-checkbox-group v-model="tagForDetail.type">
              <el-checkbox
                v-for="item in tagsForType"
                :label="item.id"
                :key="item.id"
                >{{ item.label }}</el-checkbox
              >
            </el-checkbox-group>
          </el-form-item>
          <br />
          <!-- <el-form-item label="页数: ">
            <el-input style="width: 300px" v-model.trim="detailInfo.pageCnt" />
          </el-form-item>
          <el-form-item label="字数: ">
            <el-input style="width: 300px" v-model.trim="detailInfo.wordCnt" />
          </el-form-item>
          <br /> -->
          <el-form-item label="是否母语: ">
            <el-checkbox-group v-model="tagForDetail.tongue" :max="1">
              <el-checkbox
                v-for="item in tagsForTongue"
                :label="item.id"
                :key="item.id"
                >{{ item.label }}</el-checkbox
              >
            </el-checkbox-group>
          </el-form-item>
          <br />
          <!-- <el-form-item label="YL值: ">
            <el-input style="width: 300px" v-model.trim="detailInfo.IDX_YL" />
          </el-form-item>
          <el-form-item label="AR值: ">
            <el-input style="width: 300px" v-model.trim="detailInfo.IDX_AR" />
          </el-form-item>
          <br />
          <el-form-item label="蓝思值: ">
            <el-input style="width: 300px" v-model.trim="detailInfo.IDX_LX" />
          </el-form-item>
          <el-form-item label="PERC值: ">
            <el-input style="width: 300px" v-model.trim="detailInfo.IDX_PERC" />
          </el-form-item>
          <br />

          <el-form-item label="核心词汇: ">
            <el-input
              style="width: 300px"
              v-model.number="detailInfo.vocabulary"
            />
          </el-form-item>
          <br /> -->
          <!-- <el-form-item label="CEFR值: ">
            <el-checkbox-group
              v-model="detailInfo.IDX_CEFR"
              style="width: 800px"
            >
              <el-checkbox v-for="item in cefr" :label="item" :key="item">{{
                item
              }}</el-checkbox>
            </el-checkbox-group>
          </el-form-item>
          <br /> -->
          <el-form-item label="主题: ">
            <el-checkbox-group
              v-model="tagForDetail.theme"
              style="width: 800px"
            >
              <el-checkbox
                v-for="item in tagsForTheme"
                :label="item.id"
                :key="item.id"
                >{{ item.label }}</el-checkbox
              >
            </el-checkbox-group>
          </el-form-item>
          <br />
          <el-form-item label="获奖信息: ">
            <el-checkbox-group
              v-model="tagForDetail.award"
              style="width: 800px"
            >
              <el-checkbox
                v-for="item in tagsForAward"
                :label="item.id"
                :key="item.id"
                >{{ item.label }}</el-checkbox
              >
            </el-checkbox-group>
          </el-form-item>
          <br />
        </el-form>
        <Divider />

        <el-button type="primary" @click="savemsg" style="margin-left: 460px"
          >保存</el-button
        >
      </Modal>
    </div>
  </keep-alive>
</template>

<script>
import { ApiMessage, formatDate } from "@/utils/util";
import { deepObjectCopy } from "@/utils/tools";
import addbookmsgs from "../components/addbookmsgs.vue";

export default {
  name: "bookList",
  components: { addbookmsgs },

  data() {
    return {
      cpList: [],
      cpList2: [],
      shareCPList: [],
      CPIdSet: null,
      queryData: [],
      queryNewData: [],
      newer: [],
      cefr: [
        "Pre A1",
        "A1",
        "A1+",
        "A2",
        "A2+",
        "B1",
        "B1+",
        "B2",
        "B2+",
        "C1",
        "C1+",
        "C2",
      ],
      tagsForAward: [],
      tagsForType: [],
      tagsForTongue: [],
      tagsForTheme: [],
      tagsForPublisher: [],
      tagsForAge: [],
      tagsForForm: [],
      // tagsForAward:[],
      formFuzzy: {
        bookId: "",
        bookName: "",
        dbName: "",
        pressName: "",
        IsbnName: "",
        bookBrand: "",
        state: "",
        cpId: "",
        bookLevel: "",
      },
      detailInfo: {
        nickname: "",
        ISBN: "",
        desc: "",
        pageCnt: "",
        wordCnt: "",
        IDX_YL: "",
        IDX_AR: "",
        IDX_LX: "",
        IDX_PERC: "",
        IDX_CEFR: [],
        vocabulary: null,
        buyUrls: [
          {
            name: "",
            url: "",
          },
        ],
        bindAlbum: [],
      },
      tagForDetail: {
        age: [],
        publisher: [],
        form: [],
        type: [],
        tongue: [],
        theme: [],
        award: [],
      },
      isedit: false,
      statusList: [
        {
          value: 2,
          label: "编辑中",
        },
        {
          value: 4,
          label: "审核通过",
        },
        {
          value: 5,
          label: "已上架",
        },
        {
          value: 0,
          label: "已下架",
        },
      ],
      queryParams: {
        page: 1,
        pageSize: 20,
      },
      pageTotal: 0,
      multipleSelection: [],
      order: "id,desc", //"name,asc",
      loading: true,
      brandList: [],
      currCPID: this.editCPId, //null,
      tabsValue: "",
      haveEditCPRight: false,
      allshareCPList: [],
      allCPList: [],
      IDers: [],
    };
  },
  components: {},
  props: {
    editCPId: {
      type: Number,
      default: null,
    },
    editCPName: {
      type: String,
      default: "",
    },
  },
  created() {
    this.fetchTagList();
    this.initCplist();
    console.log(this.IDers, "this.IDers=====");

  },
  computed: {},
  filters: {
    formatDate2(d) {
      return formatDate(d, "yyyy-MM-dd hh:mm:ss");
    },
  },
  mounted() {},
  watch: {},
  methods: {
    formatCEFR() {
      if (this.detailInfo.IDX_CEFR.length == 0) {
        return "";
      } else if (this.detailInfo.IDX_CEFR.length == 1) {
        return this.detailInfo.IDX_CEFR[0];
      } else {
        let str = "";
        for (let i in this.detailInfo.IDX_CEFR) {
          str += this.detailInfo.IDX_CEFR[i];
          if (i != this.detailInfo.IDX_CEFR.length - 1) {
            str += ";";
          }
        }
        return str;
      }
    },
    savemsg() {
    

      let ids = [];
      for (let i in this.multipleSelection) {
        var obj = {
          id: this.multipleSelection[i].id,
          dbId: this.multipleSelection[i].dbId,
        };
        ids.push(obj);
      }
      let tagIds = [];

      for (let i in this.tagForDetail.age) {
        tagIds.push(this.tagForDetail.age[i]);
      }
      for (let i in this.tagForDetail.publisher) {
        tagIds.push(this.tagForDetail.publisher[i]);
      }
      for (let i in this.tagForDetail.form) {
        tagIds.push(this.tagForDetail.form[i]);
      }
      for (let i in this.tagForDetail.type) {
        tagIds.push(this.tagForDetail.type[i]);
      }
      for (let i in this.tagForDetail.tongue) {
        tagIds.push(this.tagForDetail.tongue[i]);
      }
      for (let i in this.tagForDetail.theme) {
        tagIds.push(this.tagForDetail.theme[i]);
      }
      for (let i in this.tagForDetail.award) {
        tagIds.push(this.tagForDetail.award[i]);
      }
      // let content = {
      //   pageCnt: Number(this.detailInfo.pageCnt),
      //   wordCnt: Number(this.detailInfo.wordCnt),
      //   IDX_YL: this.detailInfo.IDX_YL,
      //   IDX_AR: this.detailInfo.IDX_AR,
      //   IDX_LX: this.detailInfo.IDX_LX,
      //   IDX_PERC: this.detailInfo.IDX_PERC,
      //   IDX_CEFR: this.formatCEFR(),
      //   vocabulary: this. detailInfo.vocabulary,
      // };

  
      let temp = {
        appId: this.$API.APPID,
        ids: ids,
        categoryId: 11,
        tagIds: tagIds,
        actionType: "replace",
      
      };
      this.$axios
        .post("/aries-api/resource/setTags", temp)
        .then((response) => {
          console.log(response);
          if (response.data.result == 0) {
            this.$Message.success("操作成功!");
            this.fetchQueryData();
            this.isedit = false;
            let m = response.data.data;
            for (let i in m) {
              if (m[i].id == 74) {
                this.tagList = m[i].children;
              }
            }
          } else {
            reject(null);
          }
        })
        .catch((error) => {
          ApiMessage(this, error.toString(), "error");
          reject(null);
        });
    },
    chgExpireHandle() {},
    addbookmsg() {
      if (this.multipleSelection.length == 0) {
        alert("请先勾选要添加信息的书籍");
        return;
      } else {
        this.isedit = true;
      }
    },
    handleSelect(val) {
      this.multipleSelection = val;
    },
    rowClass() {
      return "background:#f9f9f9;color:#000000;font-size:14px;height:22px";
    },
    //  fetchquery() {
    //   return new Promise((resolve, reject) => {
    //     let params = {
    //       appId:this.$API.APPID,
    //       // id: Number(this.$route.query.bookid),
    //       // dbId: Number(this.$route.query.cpid),
    //     };
    //     this.$axios
    //       .post("/aries-api/resource/get", params)
    //       .then((response) => {
    //         console.log(response);
    //         var m = response.data;
    //         // debugger
    //         if (m.result == 0) {

    //         } else {
    //           reject(null);
    //         }
    //       })
    //       .catch((error) => {
    //         ApiMessage(this, error.toString(), "error");
    //         reject(null);
    //       });
    //   });
    // },
    fetchTagList() {
      return new Promise((resolve, reject) => {
        let temp = {
          appId: this.$API.APPID,
          pid: 0,
          showAll: 1,
        };
        this.$axios
          .post("/aries-api/tag/list", temp)
          .then((response) => {
            console.log(response);
            if (response.data.result == 0) {
              let m = response.data.data;
              for (let i in m) {
                if (m[i].id == 74) {
                  this.tagList = m[i].children;
                  console.log(this.tagList, "我要的数据1111111111111111");
                  for (let i in this.tagList) {
                    if (this.tagList[i].id == 75) {
                      this.tagsForAge = this.tagList[i].children;
                    }
                    if (this.tagList[i].id == 81) {
                      this.tagsForPublisher = this.tagList[i].children;
                    }
                    if (this.tagList[i].id == 78) {
                      this.tagsForForm = this.tagList[i].children;
                    }
                    if (this.tagList[i].id == 79) {
                      this.tagsForType = this.tagList[i].children;
                    }
                    if (this.tagList[i].id == 80) {
                      this.tagsForTongue = this.tagList[i].children;
                    }
                    if (this.tagList[i].id == 77) {
                      this.tagsForTheme = this.tagList[i].children;
                    }
                    if (this.tagList[i].id == 203) {
                      this.tagsForAward = this.tagList[i].children;
                    }
                  }
                  // resolve(m);
                  // break;
                }
              }
            } else {
              reject(null);
            }
          })
          .catch((error) => {
            ApiMessage(this, error.toString(), "error");
            reject(null);
          });
      });
    },
    fetchQueryDatas() {
      let params = {
        appId: this.$API.APPID,
        //otype: 2,
        dtype: 1,
        onlyAuthorised: 1,
        needAppName: 1,
      };
      this.$axios
        .post("/aries-api/resourceDb/list", params)
        .then((response) => {
          console.log(response, "response===-------");
          if (response.data.result == 0) {
            this.queryDatas = response.data.data.own;
            //  console.log(this.queryDatas,'66666--------');
            this.loading = false;
          }
        })
        .catch((error) => {
          ApiMessage(this, error.toString(), "error");
        });
    },

    fetchQueryData() {
      // console.log(888);
      let params;
      let cpid = [];
      //cpid.push(Number(this.$route.query.cpid));
      cpid.push(this.formFuzzy.cpId);
      params = {
        appId: this.$API.APPID,
        dbId: this.IDers.id,
        sort: this.order,
        // keywords:this.formFuzzy.pressName
      };
      if (this.formFuzzy.bookId != "") {
        let bookid = [];
        bookid.push(Number(this.formFuzzy.bookId));
        params.id = bookid;
      }
      if (this.formFuzzy.bookName != "") {
        params.name = this.formFuzzy.bookName;
      }
      if (this.formFuzzy.bookBrand != "") {
        let brandId = [];
        brandId.push(Number(this.formFuzzy.bookBrand));
        params.tagIds = brandId;
      }
      if (this.formFuzzy.state !== "") {
        params.clevel = Number(this.formFuzzy.state);
      }
      let cpidList = [];
      if (this.formFuzzy.cpId != "") {
        cpidList.push(Number(this.formFuzzy.cpId));
      } else {
        this.allAllCp(cpidList);
      }
      // params.dbId = cpidList;
      var newArr = []//新的数组 获取前100个
        cpidList.forEach((item, index) => {
          // debugger
          if (index <= 99) {
            newArr.push(item)
          }
        })
         params.dbId = newArr;
      if (this.formFuzzy.bookLevel != "") {
        params.keywords = this.formFuzzy.bookLevel;
      }
      if (this.formFuzzy.pressName != "") {
        params.press = this.formFuzzy.pressName;
      }
      if (this.formFuzzy.IsbnName != "") {
        params.isbn = this.formFuzzy.IsbnName;
      }
      params.type = 10;
      params.pageSize = this.queryParams.pageSize;
      params.page = this.queryParams.page;
      // debugger
      this.$axios
        .post("/aries-api/resource/list", params)
        .then((response) => {
          if (response.data.result == 0) {
            this.pageTotal = response.data.data.pager.total;
            this.queryData = response.data.data.list;
            // console.log(this.queryDatas,"this.queryData表格中的数据=======>>>>");
            console.log(
              this.queryData,
              "this.queryDatas表格中的数据=======>>>>"
            );
            // this.queryData.forEach((item,index)=>{
            //   this.queryDatas.forEach((x,y)=>{
            //     if(item.dbId===x.id){
            //       this.newer.push(item)
            //     }
            //     // console.log(this.newer,'????');
            //   })
            // })
            this.loading = false;
          } else {
            this.loading = false;
            alert(response.data.msg);
          }
        })
        .catch((error) => {
          ApiMessage(this, error.toString(), "error");
        });
    },
    tableSortChg(val) {
      // debugger
      if (val.order == "descending") {
        this.order = val.prop + ",desc";
      } else if (val.order == "ascending") {
        this.order = val.prop + ",asc";
      }
      this.fetchQueryData();
    },
    allAllCp(cpid) {
      for (let i = 0; i < this.cpList.length; ++i) {
        cpid.push(this.cpList[i].id);
      }
    },
    onQuery() {
      this.queryParams.page = 1;
      // 获取关键字
      this.fetchQueryData();
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    addbook() {
      if (this.currCPID == null) {
        alert("请切换到具体cp下添加图书");
        return;
      }
      this.$router.push({
        name: "addbook",
        query: {
          cpid: this.currCPID,
          do: "edit",
          contentS: 1,
        },
      });
    },
    handleEdit(book) {
      let routeUrll = this.$router.resolve({
        name: "addbook",
        query: {
          cpid: book.dbId,
          bookid: book.id,
          do: "edit",
        },
      });
      window.open(routeUrll.href, "_blank");
    },
    viewHowEdit(book) {
      let routeUrll = this.$router.resolve({
        name: "addbook",
        query: {
          cpid: book.dbId,
          bookid: book.id,
          do: "view",
        },
      });
      window.open(routeUrll.href, "_blank");
    },
    multyAddBook() {
      //这里
      if (this.currCPID == null) {
        alert("请切换到具体cp下添加图书");
        return;
      }
      this.$router.push({
        name: "multyaddbook",
        query: {
          cpid: this.currCPID,
          do: "edit",
        },
      });
    },
    handleSizeChange(val) {
      this.queryParams.pageSize = val;
      this.fetchQueryData();
    },
    handleCurrentChange(val) {
      this.queryParams.page = val;
      this.fetchQueryData();
    },
    setCPList() {
      console.log(111);
      this.cpList = this.allshareCPList;
      this.setCPlist2();
    },
    setCPlist2() {
      console.log(222);

      let temp = { name: "全部" };
      this.cpList2 = deepObjectCopy(this.cpList);
      console.log(this.cpList2, "this.cplist2>>>>>>");
      let IDers = [];
      this.cpList2.map((item) => {
        this.IDers.push(item.id);
      });
      // console.log(this.IDers,'IDERS---------');
      this.cpList2.splice(0, 0, temp);
      // debugger
      this.currCPID = null;
      this.tabsValue = this.cpList2[0].name;
      if (this.editCPName != "") {
        console.log(666);
        this.currCPID = this.editCPId;
        this.tabsValue = this.editCPName;
        this.formFuzzy.cpId = this.currCPID;
      } else {
        console.log(7777);

        this.currCPID = null;
        this.tabsValue = this.cpList2[0].name;
        this.formFuzzy.cpId = "";
      }
      this.fetchQueryData();
    },
    initCplist() {
      console.log(555);
      let params = {
        appId: this.$API.APPID,
        //otype: 2,
        dtype: 1,
        onlyAuthorised: 1,
        needAppName: 1,
      };
      this.$axios
        .post("/aries-api/resourceDb/list", params)
        .then((response) => {
          console.log(response, "response===");
          if (
            response.data.data.length != 0 &&
            response.data.data.own &&
            response.data.data.own.length != 0
          ) {
            console.log(response.data.data.length);
            this.allshareCPList = response.data.data.own;
            this.getShareCPList();
          } else {
            this.loading = false;
          }
        })
        .catch((error) => {
          ApiMessage(this, error.toString(), "error");
        });
    },
    getShareCPList() {
      console.log(4444);
      if (this.allshareCPList) {
        var temp = this.allshareCPList;
      }
      if (temp != null) {
        this.allshareCPList = temp;
      }
      this.setCPList();
    },
    handleTapChange(tabName) {
      if (tabName == "全部") {
        this.currCPID = null;
        this.formFuzzy.cpId = "";
        this.haveEditCPRight = false;
      } else {
        for (let i = 0; i < this.cpList.length; ++i) {
          console.log(this.cpList, "this.cpList=====");
          if (this.tabsValue == this.cpList[i].name) {
            this.currCPID = this.cpList[i].id;
            this.formFuzzy.cpId = this.currCPID;
            if (this.cpList[i].type == "share") {
              this.haveEditCPRight = false;
            } else if (this.cpList[i].type == "own") {
              this.haveEditCPRight = true;
            }
            break;
          }
        }
      }
      this.queryParams.pageSize = 20;
      this.queryParams.page = 1;
      this.fetchQueryData();
    },
    shangxiajia(clevel) {
      if (this.multipleSelection.length == 0) {
        alert("请先选择书籍");
        return;
      }
      let ids = [];
      for (let i in this.multipleSelection) {
        let temp = {
          dbId: this.multipleSelection[i].dbId,
          id: this.multipleSelection[i].id,
        };
        ids.push(temp);
      }
      let param = {
        appId: this.$API.APPID,
        ids: ids,
        clevel: clevel,
      };
      this.sendUpDownBook(param).then((res) => {
        if (res == "success") {
          this.fetchQueryData();
        }
      });
    },
    sendUpDownBook(param) {
      return new Promise((resolve, reject) => {
        this.$axios
          .post("/aries-api/resource/online", param)
          .then((response) => {
            console.log(response);
            if (response.data.result == 0) {
              this.$Message.success("操作成功!");
              resolve(response.data.msg);
            } else {
              alert(response.data.msg);
              reject(null);
            }
          })
          .catch((error) => {
            ApiMessage(this, error.toString(), "error");
            reject(null);
          });
      });
    },
    handleDelete(id) {
      if (this.multipleSelection.length == 0) {
        alert("请先选择书籍");
        return;
      }
      this.$Modal.confirm({
        title: "确认删除？",
        content: "<ul><li>请确认是否删除书籍</li></ul>",
        onOk: () => {
          let ids = [];
          for (let i in this.multipleSelection) {
            let temp = {
              dbId: this.multipleSelection[i].dbId,
              id: this.multipleSelection[i].id,
            };
            ids.push(temp);
          }
          let params = {
            appId: this.$API.APPID,
            ids: ids,
          };
          this.$axios
            .post("/aries-api/resource/delete", params)
            .then((response) => {
              console.log(response);
              let m = response.data;
              if (m.result == 0) {
                this.fetchQueryData();
                this.$Message.success("删除成功!");
              } else {
                ApiMessage(this, m.msg, "error");
              }
            })
            .catch((error) => {
              ApiMessage(this, error.toString(), "error");
            });
        },
      });
    },
    checkBookEditRight(cpId) {
      for (let i in this.shareCPList) {
        if (this.shareCPList[i].id == Number(cpId)) {
          return true;
        }
      }
      return false;
    },
  },
};
</script>
<style lang="scss" scoped>
@import "../../fyd-style.less";
</style>



// WEBPACK FOOTER //
// bookList.vue?118aa2c8